import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-film-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                日韩伦理片
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-300">
              专注于日韩伦理剧情影视作品的资料与剧情介绍平台，带你读懂每一部作品背后的人性与情感。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-accent-400">
              快速导航
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-background-300 transition-colors hover:text-background-50">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="text-background-300 transition-colors hover:text-background-50">
                  分类片库
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-background-300 transition-colors hover:text-background-50">
                  影片搜索
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-300 transition-colors hover:text-background-50">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-accent-400">
              热门分类
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link
                  to="/category?region=日本"
                  className="text-background-300 transition-colors hover:text-background-50"
                >
                  日本伦理电影
                </Link>
              </li>
              <li>
                <Link
                  to="/category?region=韩国"
                  className="text-background-300 transition-colors hover:text-background-50"
                >
                  韩国伦理片
                </Link>
              </li>
              <li>
                <Link
                  to="/category?genre=剧情"
                  className="text-background-300 transition-colors hover:text-background-50"
                >
                  剧情佳作
                </Link>
              </li>
              <li>
                <Link
                  to="/category?genre=爱情"
                  className="text-background-300 transition-colors hover:text-background-50"
                >
                  爱情故事
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-accent-400">
              友情链接
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <a href="https://www.imdb.com" rel="nofollow" target="_blank" className="text-background-300 transition-colors hover:text-background-50">
                  IMDb 影视资料库
                </a>
              </li>
              <li>
                <a href="https://www.douban.com" rel="nofollow" target="_blank" className="text-background-300 transition-colors hover:text-background-50">
                  豆瓣电影
                </a>
              </li>
              <li>
                <a href="https://www.themoviedb.org" rel="nofollow" target="_blank" className="text-background-300 transition-colors hover:text-background-50">
                  TMDB 影片数据库
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-900 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 日韩伦理片 · 本站所有影片资料均为信息介绍用途，不提供任何在线播放服务。</p>
          <p>本站内容仅面向成年观众，请理性阅读、文明交流。</p>
        </div>
      </div>
    </footer>
  );
}